import React from 'react';

import Loader from 'components/Loader/Loader';
import CurrentReportsSitrepCard from 'components/Reports/CurrentReportsSitrepCard';
import type { GetSitrepsResponse } from 'components/Reports/reports.types';

type CurrentReportViewProps = {
  latestSitreps: Map<string, GetSitrepsResponse>;
  isLoading: boolean;
  isError: boolean;
  derivedAorId?: string | null;
};

const CurrentReportView: React.FC<CurrentReportViewProps> = ({
  latestSitreps,
  isLoading,
  isError,
  derivedAorId,
}) => {
  return (
    <div className="reports-tabs pt-3">
      {isError ? (
        <div className="mt-4 text-center">
          <span>Error loading reports.</span>
        </div>
      ) : isLoading ? (
        <Loader />
      ) : latestSitreps.size > 0 ? (
        Array.from(latestSitreps.values()).map((latestSitrep) => (
          <div key={latestSitrep.id} className="reports-tabs__latest-sitrep">
            <CurrentReportsSitrepCard sitrep={latestSitrep} />
          </div>
        ))
      ) : (
        <div className="reports-tabs__header__empty">
          <p>No SITREPs found</p>
          {!derivedAorId && (
            <div className="mt-4 text-center">
              <span>
                Unable to determine Area of Responsibility for this incident.
                Please ensure the incident is associated with an AOR in order to
                create and view draft SITREPs.
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CurrentReportView;
